import { useState, useEffect } from 'react';
import { Upload, Users, Package, FileSpreadsheet, ArrowRight, Check, SkipForward } from '../../icons/wp-icons';
import MigrationWizard from '../Settings/MigrationWizard';

function DatenImportStep({ onDataChange }) {
  const [showWizard, setShowWizard] = useState(false);
  const [importedTypes, setImportedTypes] = useState([]);
  const [skipped, setSkipped] = useState(false);

  // Onboarding-Schritt ist immer gültig (optional)
  useEffect(() => {
    onDataChange({ importedTypes, skipped }, true);
  }, [importedTypes, skipped, onDataChange]);

  const handleImportComplete = (completedTypes) => {
    setImportedTypes(prev => {
      const newTypes = [...new Set([...prev, ...completedTypes])];
      return newTypes;
    });
    setShowWizard(false);
  };

  const handleSkip = () => {
    setSkipped(true);
  };

  const hasImportedKunden = importedTypes.includes('kunde');
  const hasImportedArtikel = importedTypes.includes('katalog');

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium mb-2">Daten aus bisheriger Software übernehmen</h3>
        <p className="text-sm text-gray-600">
          Sie können Kunden und Artikel aus Ihrer bisherigen Software importieren.
          Unterstützt werden: EasyFirma, Lexoffice, sevDesk, Bitec, VERAS sowie CSV/Excel-Dateien und DATANORM-Kataloge.
        </p>
      </div>

      {/* Import-Optionen */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className={`p-4 border-2 rounded-lg transition ${
          hasImportedKunden
            ? 'border-green-300 bg-green-50'
            : 'border-gray-200 bg-gray-50'
        }`}>
          <div className="flex items-start gap-3">
            <div className={`p-2 rounded-lg ${hasImportedKunden ? 'bg-green-100' : 'bg-gray-100'}`}>
              {hasImportedKunden ? (
                <Check className="w-5 h-5 text-green-600" />
              ) : (
                <Users className="w-5 h-5 text-gray-600" />
              )}
            </div>
            <div>
              <div className="font-medium">Kunden</div>
              <div className="text-sm text-gray-500">Name, E-Mail, Adresse, Telefon</div>
              {hasImportedKunden && (
                <div className="text-xs text-green-600 mt-1">Importiert</div>
              )}
            </div>
          </div>
        </div>

        <div className={`p-4 border-2 rounded-lg transition ${
          hasImportedArtikel
            ? 'border-green-300 bg-green-50'
            : 'border-gray-200 bg-gray-50'
        }`}>
          <div className="flex items-start gap-3">
            <div className={`p-2 rounded-lg ${hasImportedArtikel ? 'bg-green-100' : 'bg-gray-100'}`}>
              {hasImportedArtikel ? (
                <Check className="w-5 h-5 text-green-600" />
              ) : (
                <Package className="w-5 h-5 text-gray-600" />
              )}
            </div>
            <div>
              <div className="font-medium">Artikel/Katalog</div>
              <div className="text-sm text-gray-500">Artikelnr, Preise, Kategorien</div>
              {hasImportedArtikel && (
                <div className="text-xs text-green-600 mt-1">Importiert</div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Aktions-Buttons */}
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={() => setShowWizard(true)}
          className="flex items-center justify-center gap-2 flex-1 px-4 py-3 bg-primary text-white rounded-button font-medium hover:bg-primary-dark transition"
        >
          <Upload className="w-5 h-5" />
          {importedTypes.length > 0 ? 'Weitere Daten importieren' : 'Wechsel-Assistent starten'}
          <ArrowRight className="w-4 h-4" />
        </button>

        {importedTypes.length === 0 && !skipped && (
          <button
            onClick={handleSkip}
            className="flex items-center justify-center gap-2 px-4 py-3 text-gray-600 hover:bg-gray-100 rounded-button transition"
          >
            <SkipForward className="w-4 h-4" />
            Überspringen
          </button>
        )}
      </div>

      {skipped && importedTypes.length === 0 && (
        <p className="text-sm text-gray-500 text-center">
          Sie können Daten jederzeit später in den Einstellungen importieren.
        </p>
      )}

      {importedTypes.length > 0 && (
        <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center gap-2 text-green-700">
            <Check className="w-5 h-5" />
            <span className="font-medium">
              {importedTypes.length === 1
                ? (hasImportedKunden ? 'Kunden' : 'Artikel') + ' erfolgreich importiert'
                : 'Kunden und Artikel erfolgreich importiert'
              }
            </span>
          </div>
        </div>
      )}

      {/* Migration Wizard Modal */}
      {showWizard && (
        <MigrationWizard
          onClose={() => setShowWizard(false)}
          onImportComplete={handleImportComplete}
          isOnboarding={true}
          alreadyImported={importedTypes}
        />
      )}
    </div>
  );
}

export default DatenImportStep;
